// extracted by mini-css-extract-plugin
export var active = "_gp-2";
export var recordingDot = "_gp-1";
export var recordingIndicator = "_gp-0";